// @ts-nocheck
import { getConfig } from '@utils/contentful'
import { useEffect, useState } from 'react'
import CXJourneyContent from '@components/cx-journey-content'

const App = props => {
  const [configData, setConfigData] = useState({
    partners: {},
    topics: [],
  })

  useEffect(() => {
    const configName = process.env.NEXT_PUBLIC_CONFIG_NAME
    const configSample = getConfig(`${configName}`)
    configSample.then(config => {
      setConfigData({
        LOB: config?.fields?.config?.LOB,
        partners: config?.fields?.config?.partners,
        topics: config?.fields?.config?.topics,
      })
    })
  }, [])

  return (
    <>
      {Object.keys(configData.topics).length > 0 && Object.keys(configData.partners).length > 0 && (
        <CXJourneyContent configData={configData} userDetail={{ email: props.email, name: props.name }} />
      )}
    </>
  )
}

export default App
